import dayjs, { Dayjs } from 'dayjs';

const SECONDS_PER_MINUTE = 60;

export function formatAiSummaryTimestamp(value: Dayjs | null) {
  // same timestamp format as the geofence triggers view
  return value ? dayjs.tz(value).format('MMM DD, YYYY HH:mm:ss Z') : '—';
}

export function formatAiSummaryMinutes(seconds: number | null) {
  return seconds === null ? '—' : (seconds / SECONDS_PER_MINUTE).toFixed(1);
}
